import {FormsModule} from "@angular/forms";
import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'nz-search-input',
    imports: [
        FormsModule
    ],
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.scss'
})
export class SearchInputComponent {
  @Input() searchValue: string = '';
  @Input() placeholder: string = '';
  @Output() onSearchValueChange: EventEmitter<string> = new EventEmitter<string>();
}
